import type { MessageHandlerResult } from "@/services/abstract/poc/MessagingService";
import type { HeliaNode } from "@/types/poc/helia";
import type { LibP2pWithServices } from "@/types/poc/libp2p";
import type { MessageHandler, MessagePayload } from "@/types/poc/message";
import { createLogger, type Logger } from "@/utils/logger";

const log: Logger = createLogger({ namespace: 'six3ro:p2p:handlers:file-replication-failed' });

type FileReplicationFailedVariant = Extract<MessageHandlerResult, { type: 'file-replication-failed' }>;

export const createFileReplicationFailedHandler = (): MessageHandler<FileReplicationFailedVariant> => ({
  canHandle: (_topic: string, message: MessagePayload): boolean =>
    message.type === 'file-replication-failed',

  process: (
    message: MessagePayload,
    _libp2p: LibP2pWithServices,
    _heliaNode: HeliaNode | null
  ): FileReplicationFailedVariant => {
    if (message.type !== 'file-replication-failed') {
      throw new Error(`Invalid message type: expected 'file-replication-failed', got '${message.type}'`);
    }

    const { cid, sixId, reason, targetPeerId, sender, timestamp } = message;
    log.info('Received file-replication-failed for CID:', cid, 'sixId:', sixId, 'reason:', reason, 'from', sender);

    return {
      type: 'file-replication-failed',
      data: {
        cid,
        sixId,
        reason,
        targetPeerId,
        sender,
        messageTimestamp: timestamp,
      },
    };
  }
});
